export default "__VITE_ASSET__B8MlU8tb__"